import React, { useReducer, useMemo } from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';

import { useSyncUser } from 'hooks/useAuth';
import RestrictedRoute from 'components/RestrictedRoute';
import AdminRoute from 'components/AdminRoute';
import UserContext, { initialSessionState } from 'context/UserSessionContext';
import UserSessionReducer from 'context/UserSessionReducer';
import ScrollToTop from 'layout/ScrollToTop';
import Admin from 'containers/admin/Admin';
import { restrictedRoutes, authRoutes } from './routes';

const App = () => {
  const [session, dispatch] = useReducer(UserSessionReducer, initialSessionState);
  const value = useMemo(() => ({ session, dispatch }), [session]);

  useSyncUser(dispatch);

  return (
    <UserContext.Provider value={value}>
      <div>
        <ScrollToTop />
        <Switch>
          {authRoutes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          ))}

          {restrictedRoutes.map(route => (
            <RestrictedRoute
              key={route.path}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          ))}
          <AdminRoute key="admin" path="/admin" component={Admin} />
        </Switch>
      </div>
    </UserContext.Provider>
  );
};

export default App;
